import { cva } from "class-variance-authority"

export const checkboxContainerVariants = cva(
  "flex items-center gap-1 rounded-sm has-[:focus-visible]:outline has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-semantic-interaction-selected",
  {
    variants: {
      alignment: {
        left: "flex-row",
        right: "flex-row-reverse",
      },
      v2: {
        true: "has-[:focus-visible]:outline-1",
        false: "has-[:focus-visible]:outline-2",
      },
    },
    defaultVariants: {
      alignment: "left",
      v2: false,
    },
  }
)

export const checkboxInputVariants = cva(
  "z-4 absolute h-5 w-5 cursor-pointer opacity-0",
  {
    variants: {
      v2: {
        true: "disabled:cursor-not-allowed",
      },
    },
    defaultVariants: {
      v2: false,
    },
  }
)

export const checkboxLabelVariants = cva(
  "cursor-pointer text-sm leading-none",
  {
    variants: {
      v2: {
        true: "disabled:cursor-not-allowed disabled:text-icon-general-disabled",
      },
    },
    defaultVariants: {
      v2: false,
    },
  }
)
